module.exports = __webpack_public_path__ + "static/media/maintenance.9062dc5c.svg";